export const blockIconsAudioandvideoPlayCircle = (
	<span className='material-symbols-outlined'>play_circle</span>
);
